
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/readme/[slug]",
      function () {
        return require("private-next-pages/readme/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/readme/[slug]"])
      });
    }
  